import { api as apiClient } from '../../../../shared/axios';
import { API_URL } from '../../../../shared/config';

const url = `${API_URL}/resource`;

export class SignInService {

    syncDataSource(config){
        const { body } = config;
        return apiClient.post(`${url}/sync/`, body);
    }
};